import {
    EntityType,
    FmtpCustomer,
    LocationInfo,
    UserPermission,
    ShippingPortalLocation,
    PermissionContext,
    CustomerInfo,
} from '@lanterds/types';

export enum Quantity {
    all = 'ALL',
    none = 'NONE',
}

export type SubRow = {
    type: string;
    displayName: string;
    id?: string;
};

export type RowColumn = {
    type: string;
    displayName: string;
    id: string;
    permission: string;
};

export type MappedPermission = {
    permission: keyof UserPermission;
    subRows: SubRow[];
    displayName: string;
    context: keyof typeof PermissionContext;
};

export type SelectedPermission = {
    displayName: string;
    name: keyof UserPermission;
    context: PermissionContext;
};

export type SelectedCustomer = CustomerInfo & {
    id: string;
    type: EntityType;
};

export type SelectedDealer = DealerHierarchyItem & {
    id: string;
    type: EntityType;
};

export interface HierarchyCustomer {
    customerName: string;
    customerId: string;
    customerCode: string;
    parentId?: string | null;
    children?: HierarchyCustomer[];
    customerParentId?: string | null;
}

export type FetchedUserPermissions = {
    userId: string;
    permissions: UserPermission;
    customerAccessList: FmtpCustomer[] | null;
    dealerAccessList: LocationInfo[] | null;
};

// Parent info is from the customer and children is the dealers
export type DealerHierarchyItem = ShippingPortalLocation & {
    children?: DealerHierarchyItem[];
    hierarchyId: string;
    name: string;
    displayName: string;
};

export type UserForm = {
    firstName: string;
    lastName: string;
    email: string;
    isFederated: boolean;
};

export interface EditUserRequestBody extends UserForm {
    permissions: UserPermission;
}

export enum AdminLabelTypes {
    Details = 'details',
    Permissions = 'permissions',
}

export enum AuthTypes {
    Internal = 'internal',
    External = 'external',
}
